export const hotlineLpSceneItems = [
    {
        id: 1,
        items: [
            {
                content: '効率的に検討を進めるための方法や工夫を解説してほしい。',
                id: 1,
            },
            {
                content: '過去の実践経験に基づくリアルなアプローチを知りたい。',
                id: 2,
            },
        ],
        title: '新規テーマ・未経験分野の検討準備に',
    },
    {
        id: 2,
        items: [
            { content: '自社の問題について第三者目線で指摘してほしい。', id: 1 },
            { content: '成果が出やすい取組みの優先順位を決めていきたい。', id: 2 },
        ],
        title: '課題を整理し、効果的な打ち手を考えたい時に',
    },
    {
        id: 3,
        items: [
            {
                content: '他社の成功・失敗事例から学ぶべきポイントを教えてほしい。',
                id: 1,
            },
            { content: 'リスク回避のための実務的な注意点を教えてほしい。', id: 2 },
        ],
        title: '社内での施策推進・成果実現に悩んだときに',
    },
    {
        id: 4,
        items: [
            {
                content: '社内では思いつかない新たなアプローチや選択肢を知りたい。',
                id: 1,
            },
            {
                content: '専門家だから知っている「プロの工夫」を教えてほしい。',
                id: 2,
            },
        ],
        title: '検討に行き詰まり、新しいヒントを得たい時に',
    },
];
